
// dataen vi bruker i søkehistorikken kommer fra bislabTransactionCollection -> bislabJson
// det er plain json og for at det skal se likt ut i nedlastet pdf fra søkehistorikk mp vi formattere alle felter
// legger på hvilken formatterings-funksjon som skal bruker her og bruker variabelen downloadSearchHistory(bool)
// for å vite i privatPDFV4 pg næringPdfV4 når vi må bruke formatterings-funksjonene.


const boolToText = (value) => (value ? 'Ja' : 'Nei');

const checkString = (value) => {
    if (value === undefined || value === null || value === '') {
      return '-'
    }
    return value.toString();
};

function formatYMDtoDMY(ymd) {
  if (typeof ymd !== 'string') return '-';
  const parts = ymd.split('-');
  if (parts.length !== 3) return '-';
  let [year, month, day] = parts;
  if (day.length === 1)   day = '0' + day;
  if (month.length === 1) month = '0' + month;
  if (!/^\d{4}$/.test(year) || !/^\d{2}$/.test(month) || !/^\d{2}$/.test(day)) {
    return '-';
  }
  return `${day}.${month}.${year}`;
}

const formatNumberWithSpaces = (num) => {
    if (num === null || num === undefined || num === '') {
        return '-';
    } else if (num === 0 || num === '0') {
        return '0';
    }
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
};


const formatNumber = (num) => {
    if (num === null || num === undefined || num === '') {
        return '-';
    } else if (num === 0 || num === '0') {
        return '0';
    }
    return num;
};

const percentFormatter = new Intl.NumberFormat('nb-NO', {
    style: 'percent',
    minimumFractionDigits: 0,
    maximumFractionDigits: 4,
});
 
export const næringConfigSearchHistory  = {
    shares: {
        header: 'Aksjer',
        subheaderKey: 'organisationName',
        fields: [
            { title: 'Org.nr.',        key: 'organisationId',             format: checkString },
            { title: 'Navn',           key: 'organisationName',           format: checkString },
            { title: 'Klasse',         key: 'shareClass',                 format: checkString },
            { title: 'Eide aksjer',    key: 'numberOfOwnedShares',        format: formatNumberWithSpaces },
            { title: 'Totale aksjer',  key: 'totalNumberOfCompanyShares', format: formatNumberWithSpaces },
            { title: 'Eierandel',      key: 'shareOfOwnership',           format: percentFormatter.format },
        ],
    },
    shareholders: {
        header: 'Aksjonærer',
        subheaderKey: 'shareClass',
        fields: [
            { title: 'Navn',           key: 'owner.name',                 format: checkString },
            { title: 'Eiertype',       key: 'owner.type',                 format: checkString },
            { title: 'Klasse',         key: 'shareClass',                 format: checkString },
            { title: 'Eide aksjer',    key: 'numberOfOwnedShares',        format: formatNumberWithSpaces },
            { title: 'Totale aksjer',  key: 'totalNumberOfCompanyShares', format: formatNumberWithSpaces },
            { title: 'Eierandel',      key: 'shareOfOwnership',           format: percentFormatter.format },
        ],
    },
    paymentRemarks: {
        header: 'Betalingsanmerkninger',
        subheaderKey: 'creditor',
        fields: [
            { title: 'Kreditor',         key: 'creditor',         format: checkString },
            { title: 'Saknr.',           key: 'caseNumber',       format: checkString },
            { title: 'Reg.dato',         key: 'registrationDate', format: formatYMDtoDMY },
            { title: 'Status',           key: 'settlementStatus', format: checkString },
            { title: 'Oppgj.dato',       key: 'settlementDate',   format: formatYMDtoDMY },
            { title: 'Byrå',             key: 'collectionAgency', format: checkString },
            { title: 'Kode',             key: 'typeCode',         format: checkString },
            { title: 'Beskr.',           key: 'typeDescription',  format: checkString },
            { title: 'Hend.type',        key: 'caseEventType',    format: checkString },
            { title: 'Beløp',            key: 'amount',           format: formatNumberWithSpaces },
        ],
    },
    movableAssets: {
        header: 'Pant',
        subheaderKey: 'documentNumber',
        fields: [
            { title: 'Dok.nr.',           key: 'documentNumber',                     format: checkString },
            { title: 'Fullbyrd.',         key: 'enforced',                           format: boolToText },
            { title: 'Utl.tidsp',         key: 'expiryDateLegalProtection',          format: formatYMDtoDMY },
            { title: 'Eiendel',           key: 'asset.type',                         format: checkString },
            { title: 'Panthever Navn',    key: 'roles[0].roleHolder.name',           format: checkString },
            { title: 'Panthever Org.ID',  key: 'roles[0].roleHolder.organisationId', format: checkString },
            { title: 'Pantsetter Navn',   key: 'roles[1].roleHolder.name',           format: checkString },
            { title: 'Pantsetter Org.ID', key: 'roles[1].roleHolder.organisationId', format: checkString },
        ],
    },
    propertyForeclosures: {
        header: 'Tvangsfullbyrdelse av eiendom',
        subheaderKey: 'id',
        fields: [
            { title: 'ID',           key: 'id',                                  format: checkString },
            { title: 'Grunnlag',     key: 'legalFoundation',                     format: checkString },
            { title: 'Ansvar',       key: 'directResponsibility',                format: boolToText },
            { title: 'Oppdatert',    key: 'updatedDate',                         format: formatYMDtoDMY },
            { title: 'Reg.dato',     key: 'registeredDate',                      format: formatYMDtoDMY },
            { title: 'Fl.eiend.',    key: 'registeredOnMultipleProperties',      format: boolToText },
            { title: 'Saksøkte',     key: 'multipleDefendants',                  format: boolToText },
            { title: 'Beløp',        key: 'amount.amount',                       format: formatNumberWithSpaces },
            { title: 'Kravst.',      key: 'claimant.name',                       format: checkString },
            { title: 'Fullm.',       key: 'processRepresentativeAgents[0].name', format: checkString },
        ],
    },
    propertyEnforcedActionRemarks: {
        header: 'Merknader om eiendomstvangsforretning',
        subheaderKey: 'id',
        fields: [
            { title: 'ID',           key: 'id',                             format: checkString },
            { title: 'Reg.dato',     key: 'registeredDate',                 format: formatYMDtoDMY },
            { title: 'Fl.eiend.',    key: 'registeredOnMultipleProperties', format: boolToText },
            { title: 'Ansvar',       key: 'directResponsibility',           format: boolToText },
            { title: 'Saksnr.',      key: 'caseNumber',                     format: checkString },
            { title: 'Grunnlag',     key: 'legalFoundation',                format: checkString },
            { title: 'Fritekst',     key: 'freeText',                       format: checkString },
            { title: 'Tingrett',     key: 'districtCourt',                  format: checkString },
            { title: 'Bobestyrer',   key: 'estateManager',                  format: checkString },
        ],
    },
    financialStatements: {
        header: 'Regnskap',
        subheaderKey: 'financialYear',
        groupSizes: [2, 6],
        groupHeaders: ['Regnskapsperiode', 'Generell informasjon', 'Resultatregnskap'],
        fields: [
            { title: 'Fra dato',                            key: 'fromDate',                  format: formatYMDtoDMY },
            { title: 'Til dato',                            key: 'toDate',                    format: formatYMDtoDMY },
            { title: 'Morselskap',                          key: 'parentCompany',             format: boolToText },
            { title: 'Avviklingsregnskap',                  key: 'liquidationAccounts',       format: boolToText },
            { title: 'Oppstillingsplan',                    key: 'presentationPlan',          format: checkString },
            { title: 'Ikke-revidert årsregnskap',           key: 'nonAuditedAnnualReport',    format: boolToText },
            { title: 'Fravalg revisjon',                    key: 'optedOutOfAudit',           format: boolToText },
            { title: 'Småforetak',                          key: 'smallEnterprise',           format: boolToText },
            { title: 'Driftsinntekter',                     key: 'operatingIncome',           format: formatNumberWithSpaces },
            { title: 'Driftskostnad',                       key: 'operatingExpenses',         format: formatNumberWithSpaces },
            { title: 'Driftsresultat',                      key: 'operatingProfit',           format: formatNumberWithSpaces },
            { title: 'Finansinntekter',                     key: 'financialIncome',           format: formatNumberWithSpaces },
            { title: 'Finanskostnad',                       key: 'financialExpenses',         format: formatNumberWithSpaces },
            { title: 'Netto finans',                        key: 'netFinancials',             format: formatNumberWithSpaces },
            { title: 'Ordinært resultat før skattekostnad', key: 'ordinaryResultBeforeTax',   format: formatNumberWithSpaces },
            { title: 'Årsresultat',                         key: 'annualProfit',              format: formatNumberWithSpaces },
            { title: 'Total resultat',                      key: 'totalProfit',               format: formatNumberWithSpaces },
            { title: 'Anleggsmidler',                       key: 'fixedAssets',               format: formatNumberWithSpaces },
            { title: 'Omløpsmidler',                        key: 'currentAssets',             format: formatNumberWithSpaces },
            { title: 'Sum Eiendeler',                       key: 'totalAssets',               format: formatNumberWithSpaces },
            { title: 'Langsiktig gjeld',                    key: 'longTermLiabilities',       format: formatNumberWithSpaces },
            { title: 'Kortsiktig gjeld',                    key: 'shortTermLiabilities',      format: formatNumberWithSpaces },
            { title: 'Sum gjeld',                           key: 'totalLiabilities',          format: formatNumberWithSpaces },
            { title: 'Innskutt egenkaptial',                key: 'paidInEquity',              format: formatNumberWithSpaces },
            { title: 'Opptjent egenkapital',                key: 'earnedEquity',              format: formatNumberWithSpaces },
            { title: 'Sum egenkapital gjeld',               key: 'totalEquityAndLiabilities', format: formatNumberWithSpaces },
            { title: 'Sum egenkapital',                     key: 'totalEquity',               format: formatNumberWithSpaces },
        ],
    },
    roles: {
        header: 'Roller',
        subheaderKey: 'description',
        fields: [
            { title: 'Rolletype',   key: 'description',    format: checkString },
            { title: 'Navn',        key: 'name',           format: checkString },
            { title: 'Type',        key: 'type',           format: checkString },
            { title: 'Org.ID',      key: 'organisationId', format: checkString },
            { title: 'Fødselsdato', key: 'birthYear',      format: formatYMDtoDMY },
        ],
    },
    properties: {
        header: 'Eiendom',
        subheaderKey: 'propertyType',
        fields: [
            { title: 'Heftelser',   key: 'liens.length',                format: formatNumber },
            { title: 'Type',        key: 'info.propertyType',           format: checkString },
            { title: 'Formål',      key: 'info.type',                   format: checkString },
            { title: 'Hjemmel',     key: 'info.ownershipRights',        format: checkString },
            { title: 'Eierandel',   key: 'info.shareOfOwnership',       format: percentFormatter.format },
            { title: 'Reg.enh. ID', key: 'info.registerUnitId',         format: checkString },
            { title: 'Adresse',     key: 'info.address',                format: checkString },
            { title: 'Postnr.',     key: 'info.zipCode',                format: checkString },
            { title: 'Poststed',    key: 'info.postalAddress',          format: checkString },
            { title: 'Salg.dato',   key: 'valuation.previousSaleDate',  format: formatYMDtoDMY },
            { title: 'Salg.pris',   key: 'valuation.previousSalePrice', format: formatNumberWithSpaces },
            { title: 'Est.pris',    key: 'valuation.estimatedPrice',    format: formatNumberWithSpaces },
            { title: 'Brukstype',   key: 'info.propertyType',           format: checkString },
            { title: 'Boligtype',   key: 'info.type',                   format: checkString },
            { title: 'Kom.nr.',     key: 'info.municipalityNumber',     format: checkString },
            { title: 'Gnr.',        key: 'info.cadastralUnitNumber',    format: checkString },
            { title: 'Bnr.',        key: 'info.unitNumber',             format: checkString },
        ],
    },
    propertiesLiens: {
        header: 'Heftelser (Eiendom)',
        subheaderKey: 'id',
        fields: [
            { title: 'ID',               key: 'id',                                  format: checkString },
            { title: 'Type',             key: 'type',                                format: checkString },
            { title: 'Jur.grunnlag',     key: 'legalFoundation',                     format: checkString },
            { title: 'Direkte ansvar',   key: 'directResponsibility',                format: boolToText },
            { title: 'Flere eiendommer', key: 'registeredOnMultipleProperties',      format: boolToText },
            { title: 'Tot.pant',         key: 'amounts[0].amount',                   format: formatNumberWithSpaces },
            { title: 'Est. tot.pant',    key: 'amounts[0].estimatedRemainingAmount', format: formatNumberWithSpaces },
            { title: 'Valuta',           key: 'amounts[0].currency',                 format: checkString },
            { title: 'Oppd.dato',        key: 'updatedDate',                         format: formatYMDtoDMY },
            { title: 'Reg.dato',         key: 'registeredDate',                      format: formatYMDtoDMY },
            { title: 'Rett.haver type',  key: 'rightsHolders[0].name',               format: checkString },
            { title: 'Rett.haver navn',  key: 'rightsHolders[0].organisationId',     format: checkString },
            { title: 'Rett.haver orgid', key: 'rightsHolders[0].name',               format: checkString },
        ],
    },
    vehicles: {
        header: 'Kjøretøy',
        subheaderKey: 'registrationNumber',
        fields: [
            { title: 'Antall heftelser', key: 'liens.length',                        format: formatNumber },
            { title: 'Reg.nr.',          key: 'info.registrationNumber',             format: checkString },
            { title: 'Type',             key: 'info.vehicleType',                    format: checkString },
            { title: 'Merke',            key: 'info.brand',                          format: checkString },
            { title: 'Modell',           key: 'info.model',                          format: checkString },
            { title: 'Først.reg.',       key: 'info.firstRegistrationDate',          format: formatYMDtoDMY },
            { title: 'Reg.stat.',        key: 'info.registrationStatus',             format: checkString },
            { title: 'Forh.pris',        key: 'valuation.estimatedDealerPrice',      format: formatNumberWithSpaces },
            { title: 'Priv.pris',        key: 'valuation.estimatedPrivateSalePrice', format: formatNumberWithSpaces },
        ],
    },
    vehicleLiens: {
        header: 'Heftelser (Kjøretøy)',
        subheaderKey: 'id',
        fields: [
            { title: 'Dok.nr',               key: 'documentNumber',               format: checkString },
            { title: 'Type',                 key: 'type',                         format: checkString },
            { title: 'Reg.tidspunkt',        key: 'entryTimestamp',               format: checkString },
            { title: 'Vedtakstidspunkt',     key: 'decisionTimestamp',            format: checkString },
            { title: 'Utløpsdato rettsvern', key: 'expiryDateLegalProtection',    format: formatYMDtoDMY },
            { title: 'Beløp',                key: 'amounts[0].amount',            format: formatNumberWithSpaces },
            { title: 'valuta',               key: 'amounts[0].currency',          format: checkString },
            { title: 'Pantsetter type',      key: 'mortagor[0].type',             format: checkString },
            { title: 'Pantsetter orgid',     key: 'mortagor[0].organisationId',   format: checkString },
            { title: 'Pantsetter navn',      key: 'mortagor[0].name',             format: checkString },
            { title: 'Panthaver type',       key: 'lienHolder[0].type',           format: checkString },
            { title: 'Panthaver orgid',      key: 'lienHolder[0].organisationId', format: checkString },
            { title: 'Panthaver navn',       key: 'lienHolder[0].name',           format: checkString },
        ],
    },
    oversikt: {
        header: 'Kredittvurdering',
        fields: [
            { title: 'Kredittvurdering karakter',       key: 'scoreRating',                     format: checkString },
            { title: 'Kredittvurdering score',          key: 'normalisedScore',                 format: checkString },
            { title: 'Kredittvurdering forklaring',     key: 'scoreRatingExplanation',          format: checkString },
            { title: 'Råscore',                         key: 'rawScore',                        format: formatNumberWithSpaces },
            { title: 'Sannsynlighet for mislighold',    key: 'probabilityOfDefault',            format: percentFormatter.format },
            { title: 'Forslag til kredittgrensen(NOK)', key: 'creditLimit',                     format: formatNumberWithSpaces },
            { title: 'Betalingsanmerkninger antall',    key: 'summary.paymentRemarksCount',     format: formatNumber },
            { title: 'Betalingsanmerkninger beløp',     key: 'summary.paymentRemarksAmount',    format: formatNumberWithSpaces },
            { title: 'Intet til utlegg antall',         key: 'summary.noAssetsForSeizureCount', format: formatNumber },
        ],
    },
    grunndata: {
        header: 'Grunndata',
        fields: [
              { title: 'Foretaksnavn',      key: 'organisationName',  format: checkString },
              { title: 'Organisasjonsform', key: 'organisationForm',  format: checkString },
              { title: 'Stiftelsesdato',    key: 'establishmentDate', format: formatYMDtoDMY },
              { title: 'Antall ansatte',    key: 'numberOfEmployees', format: formatNumber },
              { title: 'Status',            key: 'status',            format: checkString },
              { title: 'Status dato',       key: 'statusDate',        format: formatYMDtoDMY },
              { title: 'Kredittsperre',     key: 'creditFreeze',      format: boolToText },
        ],
    },
    pant: {
        header: 'Pant',
        fields: [
            { title: 'Utleggspant antall',        key: 'summary.assetSeizureCount',         format: formatNumber },
            { title: 'Utleggspant beløp',         key: 'summary.assetSeizureAmount',        format: formatNumberWithSpaces },
            { title: 'Tvangsforretninger antall', key: 'summary.propertyForeclosureCount',  format: formatNumber },
            { title: 'Tvangsforretninger beløp',  key: 'summary.propertyForeclosureAmount', format: formatNumberWithSpaces  },
            { title: 'Arrest antall',             key: 'summary.arrestCount',               format: formatNumber },
            { title: 'Arrest beløp',              key: 'summary.arrestAmount',              format: formatNumberWithSpaces },
        ],
    },
};


export const privatConfigSearchHistory  = {
    shares: {
        header: 'Aksjer',
        subheaderKey: 'organisationName',
        fields: [
            { title: 'Org.nr.',        key: 'organisationId',             format: checkString },
            { title: 'Navn',           key: 'organisationName',           format: checkString },
            { title: 'Klasse',         key: 'shareClass',                 format: checkString },
            { title: 'Eide aksjer',    key: 'numberOfOwnedShares',        format: formatNumberWithSpaces },
            { title: 'Totale aksjer',  key: 'totalNumberOfCompanyShares', format: formatNumberWithSpaces },
            { title: 'Eierandel',      key: 'shareOfOwnership',           format: percentFormatter.format },
        ],
    },
    shareholders: {
        header: 'Aksjonærer',
        subheaderKey: 'shareClass',
        fields: [
            { title: 'Navn',           key: 'owner.name',                 format: checkString },
            { title: 'Eiertype',       key: 'owner.type',                 format: checkString },
            { title: 'Klasse',         key: 'shareClass',                 format: checkString },
            { title: 'Eide aksjer',    key: 'numberOfOwnedShares',        format: formatNumberWithSpaces },
            { title: 'Totale aksjer',  key: 'totalNumberOfCompanyShares', format: formatNumberWithSpaces },
            { title: 'Eierandel',      key: 'shareOfOwnership',           format: percentFormatter.format },
        ],
    },
    paymentRemarks: {
        header: 'Betalingsanmerkninger',
        subheaderKey: 'creditor',
        fields: [
            { title: 'Kreditor',         key: 'creditor',         format: checkString },
            { title: 'Saknr.',           key: 'caseNumber',       format: checkString },
            { title: 'Reg.dato',         key: 'registrationDate', format: formatYMDtoDMY },
            { title: 'Status',           key: 'settlementStatus', format: checkString },
            { title: 'Oppgj.dato',       key: 'settlementDate',   format: formatYMDtoDMY },
            { title: 'Byrå',             key: 'collectionAgency', format: checkString },
            { title: 'Kode',             key: 'typeCode',         format: checkString },
            { title: 'Beskr.',           key: 'typeDescription',  format: checkString },
            { title: 'Hend.type',        key: 'caseEventType',    format: checkString },
            { title: 'Beløp',            key: 'amount',           format: formatNumberWithSpaces },
        ],
    },
    salaryDeductions: {
        header: 'Utleggstrekk',
        subheaderKey: 'caseNumber',
        fields: [
            { title: 'Saknr.',           key: 'caseNumber',                                format: checkString },
            { title: 'Mnd.beløp',        key: 'monthlyAmount',                             format: formatNumberWithSpaces },
            { title: 'Start',            key: 'startDate',                                 format: formatYMDtoDMY },
            { title: 'Slutt',            key: 'endDate',                                   format: formatYMDtoDMY },
            { title: 'Avh.forr.',        key: 'hearingHeld',                               format: checkString },
            { title: 'Søker org.nr.',    key: 'claimant.organisationId',                   format: checkString },
            { title: 'Søker navn',       key: 'claimant.name',                             format: checkString },
            { title: 'Fullm. org.nr.',   key: 'processRepresentativeAgent.organisationId', format: checkString },
            { title: 'Fullm. navn',      key: 'processRepresentativeAgent.name',           format: checkString },
            { title: 'Namsm. org.nr.',   key: 'enforcementAuthority.organisationId',       format: checkString },
            { title: 'Namsm. navn',      key: 'enforcementAuthority.name',                 format: checkString },
        ],
    },
    noAssetsForSeizure: {
        header: 'Intet Til Utlegg',
        subheaderKey: 'caseNumber',
        fields: [
            { title: 'Sak.nr.',          key: 'caseNumber',                                format: checkString },
            { title: 'Avh.forr.',        key: 'hearingHeld',                               format: checkString },
            { title: 'Søker org.nr.',    key: 'claimant.organisationId',                   format: checkString },
            { title: 'Søker navn',       key: 'claimant.name',                             format: checkString },
            { title: 'Fullm. org.nr.',   key: 'processRepresentativeAgent.organisationId', format: checkString },
            { title: 'Fullm. navn',      key: 'processRepresentativeAgent.name',           format: checkString },
            { title: 'Namsm. org.nr.',   key: 'enforcementAuthority.organisationId',       format: checkString },
            { title: 'Namsm. navn',      key: 'enforcementAuthority.name',                 format: checkString },
        ],
    },
    movableAssets: {
        header: 'Pant',
        subheaderKey: 'documentNumber',
        fields: [
            { title: 'Dok.nr.',           key: 'documentNumber',                     format: checkString },
            { title: 'Fullbyrd.',         key: 'enforced',                           format: boolToText },
            { title: 'Utl.tidsp',         key: 'expiryDateLegalProtection',          format: formatYMDtoDMY },
            { title: 'Eiendel',           key: 'asset.type',                         format: checkString },
            { title: 'Panthever Navn',    key: 'roles[0].roleHolder.name',           format: checkString },
            { title: 'Panthever Org.ID',  key: 'roles[0].roleHolder.organisationId', format: checkString },
            { title: 'Pantsetter Navn',   key: 'roles[1].roleHolder.name',           format: checkString },
            { title: 'Pantsetter Org.ID', key: 'roles[1].roleHolder.organisationId', format: checkString },
        ],
    },
    propertyForeclosures: {
        header: 'Tvangsfullbyrdelse av eiendom',
        subheaderKey: 'id',
        fields: [
            { title: 'ID',           key: 'id',                                  format: checkString },
            { title: 'Grunnlag',     key: 'legalFoundation',                     format: checkString },
            { title: 'Ansvar',       key: 'directResponsibility',                format: boolToText },
            { title: 'Oppdatert',    key: 'updatedDate',                         format: formatYMDtoDMY },
            { title: 'Reg.dato',     key: 'registeredDate',                      format: formatYMDtoDMY },
            { title: 'Fl.eiend.',    key: 'registeredOnMultipleProperties',      format: boolToText },
            { title: 'Saksøkte',     key: 'multipleDefendants',                  format: boolToText },
            { title: 'Beløp',        key: 'amount.amount',                       format: formatNumberWithSpaces },
            { title: 'Kravst.',      key: 'claimant.name',                       format: checkString },
            { title: 'Fullm.',       key: 'processRepresentativeAgents[0].name', format: checkString },
        ],
    },
    propertyEnforcedActionRemarks: {
        header: 'Merknader om eiendomstvangsforretning',
        subheaderKey: 'id',
        fields: [
            { title: 'ID',           key: 'id',                             format: checkString },
            { title: 'Reg.dato',     key: 'registeredDate',                 format: formatYMDtoDMY },
            { title: 'Fl.eiend.',    key: 'registeredOnMultipleProperties', format: boolToText },
            { title: 'Ansvar',       key: 'directResponsibility',           format: boolToText },
            { title: 'Saksnr.',      key: 'caseNumber',                     format: checkString },
            { title: 'Grunnlag',     key: 'legalFoundation',                format: checkString },
            { title: 'Fritekst',     key: 'freeText',                       format: checkString },
            { title: 'Tingrett',     key: 'districtCourt',                  format: checkString },
            { title: 'Bobestyrer',   key: 'estateManager',                  format: checkString },
        ],
    },
    incomeStatements: {
      header: 'Ligninger',
      subheaderKey: 'taxYear',
      fields: [
        { title: 'Ligningsår',    key: 'taxYear',   format: checkString },
        { title: 'Skatteklasse',  key: 'taxClass',  format: checkString },
        { title: 'Netto inntekt', key: 'netIncome', format: formatNumberWithSpaces },
        { title: 'Netto formue',  key: 'netWealth', format: formatNumberWithSpaces },
        { title: 'Skatt',         key: 'tax',       format: formatNumberWithSpaces },
      ],
    },
    roles: {
        header: 'Roller',
        subheaderKey: 'description',
        fields: [
            { title: 'Org.ID',       key: 'organisationId',   format: checkString },
            { title: 'Foretaksnavn', key: 'organisationName', format: checkString },
            { title: 'Beskrivelse',  key: 'description',      format: checkString },
            { title: 'Daglig leder', key: 'dagligLeder',      format: checkString },
            { title: 'Styreleder',   key: 'styreleder',       format: checkString },
            { title: 'Styremedlem',  key: 'styremedlem',      format: checkString },
            { title :'Nestleder',    key: 'nestleder',        format: checkString },
        ],
    },
    properties: {
        header: 'Eiendom',
        subheaderKey: 'propertyType',
        fields: [
            { title: 'Heftelser',   key: 'liens.length',                format: formatNumber },
            { title: 'Type',        key: 'info.propertyType',           format: checkString },
            { title: 'Formål',      key: 'info.type',                   format: checkString },
            { title: 'Hjemmel',     key: 'info.ownershipRights',        format: checkString },
            { title: 'Eierandel',   key: 'info.shareOfOwnership',       format: percentFormatter.format },
            { title: 'Reg.enh. ID', key: 'info.registerUnitId',         format: checkString },
            { title: 'Adresse',     key: 'info.address',                format: checkString },
            { title: 'Postnr.',     key: 'info.zipCode',                format: checkString },
            { title: 'Poststed',    key: 'info.postalAddress',          format: checkString },
            { title: 'Salg.dato',   key: 'valuation.previousSaleDate',  format: formatYMDtoDMY },
            { title: 'Salg.pris',   key: 'valuation.previousSalePrice', format: formatNumberWithSpaces },
            { title: 'Est.pris',    key: 'valuation.estimatedPrice',    format: formatNumberWithSpaces },
            { title: 'Brukstype',   key: 'info.propertyType',           format: checkString },
            { title: 'Boligtype',   key: 'info.type',                   format: checkString },
            { title: 'Kom.nr.',     key: 'info.municipalityNumber',     format: checkString },
            { title: 'Gnr.',        key: 'info.cadastralUnitNumber',    format: checkString },
            { title: 'Bnr.',        key: 'info.unitNumber',             format: checkString },
        ],
    },
    propertiesLiens: {
        header: 'Heftelser (Eiendom)',
        subheaderKey: 'id',
        fields: [
            { title: 'ID',               key: 'id',                                  format: checkString },
            { title: 'Type',             key: 'type',                                format: checkString },
            { title: 'Jur.grunnlag',     key: 'legalFoundation',                     format: checkString },
            { title: 'Direkte ansvar',   key: 'directResponsibility',                format: boolToText },
            { title: 'Flere eiendommer', key: 'registeredOnMultipleProperties',      format: boolToText },
            { title: 'Tot.pant',         key: 'amounts[0].amount',                   format: formatNumberWithSpaces },
            { title: 'Est. tot.pant',    key: 'amounts[0].estimatedRemainingAmount', format: formatNumberWithSpaces },
            { title: 'Valuta',           key: 'amounts[0].currency',                 format: checkString },
            { title: 'Oppd.dato',        key: 'updatedDate',                         format: formatYMDtoDMY },
            { title: 'Reg.dato',         key: 'registeredDate',                      format: formatYMDtoDMY },
            { title: 'Rett.haver type',  key: 'rightsHolders[0].name',               format: checkString },
            { title: 'Rett.haver navn',  key: 'rightsHolders[0].organisationId',     format: checkString },
            { title: 'Rett.haver orgid', key: 'rightsHolders[0].name',               format: checkString },
        ],
    },
    vehicles: {
        header: 'Kjøretøy',
        subheaderKey: 'registrationNumber',
        fields: [
            { title: 'Antall heftelser', key: 'liens.length',                        format: formatNumber },
            { title: 'Reg.nr.',          key: 'info.registrationNumber',             format: checkString },
            { title: 'Type',             key: 'info.vehicleType',                    format: checkString },
            { title: 'Merke',            key: 'info.brand',                          format: checkString },
            { title: 'Modell',           key: 'info.model',                          format: checkString },
            { title: 'Først.reg.',       key: 'info.firstRegistrationDate',          format: formatYMDtoDMY },
            { title: 'Reg.stat.',        key: 'info.registrationStatus',             format: checkString },
            { title: 'Forh.pris',        key: 'valuation.estimatedDealerPrice',      format: formatNumberWithSpaces },
            { title: 'Priv.pris',        key: 'valuation.estimatedPrivateSalePrice', format: formatNumberWithSpaces },
        ],
    },
    vehicleLiens: {
        header: 'Heftelser (Kjøretøy)',
        subheaderKey: 'id',
        fields: [
            { title: 'Dok.nr',               key: 'documentNumber',               format: checkString },
            { title: 'Type',                 key: 'type',                         format: checkString },
            { title: 'Reg.tidspunkt',        key: 'entryTimestamp',               format: checkString },
            { title: 'Vedtakstidspunkt',     key: 'decisionTimestamp',            format: checkString },
            { title: 'Utløpsdato rettsvern', key: 'expiryDateLegalProtection',    format: formatYMDtoDMY },
            { title: 'Beløp',                key: 'amounts[0].amount',            format: formatNumberWithSpaces },
            { title: 'valuta',               key: 'amounts[0].currency',          format: checkString },
            { title: 'Pantsetter type',      key: 'mortagor[0].type',             format: checkString },
            { title: 'Pantsetter orgid',     key: 'mortagor[0].organisationId',   format: checkString },
            { title: 'Pantsetter navn',      key: 'mortagor[0].name',             format: checkString },
            { title: 'Panthaver type',       key: 'lienHolder[0].type',           format: checkString },
            { title: 'Panthaver orgid',      key: 'lienHolder[0].organisationId', format: checkString },
            { title: 'Panthaver navn',       key: 'lienHolder[0].name',           format: checkString },
        ],
    },
    oversikt: {
        header: 'Kredittvurdering',
        fields: [
            { title: 'Kredittvurdering karakter',       key: 'scoreRating',                             format: checkString },
            { title: 'Kredittvurdering score',          key: 'normalisedScore',                         format: checkString },
            { title: 'Kredittvurdering forklaring',     key: 'scoreRatingExplanation',                  format: checkString },
            { title: 'Råscore',                         key: 'rawScore',                                format: formatNumberWithSpaces },
            { title: 'Sannsynlighet for mislighold',    key: 'probabilityOfDefault',                    format: percentFormatter.format },
            { title: 'Forslag til kredittgrensen(NOK)', key: 'creditLimit',                             format: formatNumberWithSpaces },
            { title: 'Betalingsanmerkninger antall',    key: 'summary.paymentRemarksCount',             format: formatNumber },
            { title: 'Betalingsanmerkninger beløp',     key: 'summary.paymentRemarksAmount',            format: formatNumberWithSpaces },
            { title: 'Gjeldsordning åpning antall',     key: 'summary.debtRestructuringOpenedCount',    format: formatNumber },
            { title: 'Gjeldsordning frivillig antall',  key: 'summary.debtRestructuringVoluntaryCount', format: formatNumber },
            { title: 'Gjeldsordning tvungen antall',    key: 'summary.debtRestructuringForcedCount',    format: formatNumber },
            { title: 'Intet til utlegg antall',         key: 'summary.noAssetsForSeizureCount',         format: formatNumber },
            { title: 'Utleggstrekk antall',             key: 'summary.assetSeizureCount',               format: formatNumber },
            { title: 'Utleggstrekk beløp',              key: 'summary.assetSeizureAmount',              format: formatNumberWithSpaces },
        ],
    },
    grunndata: {
        header: 'Grunndata',
        fields: [
              { title: 'Fødselsdato',    key: 'birthDate',         format: formatYMDtoDMY },
              { title: 'Fornavn',        key: 'firstName',         format: checkString },
              { title: 'Etternavn',      key: 'lastName',          format: checkString },
              { title: 'Status',         key: 'status',            format: checkString },
              { title: 'Under vergemål', key: 'underGuardianship', format: boolToText },
        ],
    },
    pant: {
        header: 'Pant',
        fields: [
            { title: 'Utleggspant antall',        key: 'summary.assetSeizureCount',         format: formatNumber },
            { title: 'Utleggspant beløp',         key: 'summary.assetSeizureAmount',        format: formatNumberWithSpaces },
            { title: 'Tvangsforretninger antall', key: 'summary.propertyForeclosureCount',  format: formatNumber },
            { title: 'Tvangsforretninger beløp',  key: 'summary.propertyForeclosureAmount', format: formatNumberWithSpaces  },
            { title: 'Arrest antall',             key: 'summary.arrestCount',               format: formatNumber },
            { title: 'Arrest beløp',              key: 'summary.arrestAmount',              format: formatNumberWithSpaces },
        ],
    },
    eiendeler: {
        header: 'Eiendeler',
        fields: [
            { title: 'Eiendom antall',         key: 'properties.length',                     format: formatNumber },
            { title: 'Kjøretøy antall',        key: 'vehicles.length',                       format: formatNumber },
            { title: 'Enkeltpersonforetak',    key: 'risk.summary.soleProprietor',           format: boolToText },
            { title: 'Majoritetseier selskap', key: 'risk.summary.majorityOwnerCorporation', format: boolToText}
        ],
    },
};